import { render, staticRenderFns } from "./vipGift.vue?vue&type=template&id=252241c4&scoped=true&"
import script from "./vipGift.vue?vue&type=script&lang=js&"
export * from "./vipGift.vue?vue&type=script&lang=js&"
import style0 from "./vipGift.vue?vue&type=style&index=0&id=252241c4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252241c4",
  null
  
)

export default component.exports